<template>
  <div>
    <button v-if="!rawJson" @click="toggleRaw">Show Raw JSON</button>
    <button v-if="rawJson" @click="toggleRaw">Hide Raw Json</button>
    <div v-if="rawJson">
      <RawJson :raw="json" />
    </div>
    <button v-if="rawJson" @click="toggleRaw">Hide Raw Json</button>
  </div>
</template>

<script>
import RawJson from '@/components/RawJson.vue'

export default {
  name: 'RawJsonToggler',
  props: {
    json: Object
  },
  data() {
    return {
      rawJson: false
    }
  },
  methods: {
    toggleRaw() {
      this.rawJson = !this.rawJson
    }
  },
  components: {
    RawJson
  }
}
</script>
